// src/pages/info/CheckDetails.jsx

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../components/Directory/DirectoryTable.css';
import './CheckDetails.css';
import DeleteConfirmationModal from '../../components/Modals/DeleteConfirmationModal';
import API_BASE_URL from '../../config';

const CheckDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [problemsRes, collectorsRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/breake_problem/list_problems`),
          axios.get(`${API_BASE_URL}/collector/get_all_collectors`)
        ]);

        const problem = problemsRes.data.find(p => p.id === Number(id));
        if (!problem) {
          setError('Поломка не найдена');
          return;
        }

        const collector = collectorsRes.data.find(c => c.id === problem.collector_id);
        setRecord({
          ...problem,
          collector_name: collector?.name || `Коллектор ${problem.collector_id}`,
          is_operational: collector?.is_operational
        });
      } catch (e) {
        console.error('Ошибка загрузки данных:', e);
        setError('Не удалось загрузить данные');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleConfirmDelete = async () => {
    setDeleteInProgress(true);
    try {
      await axios.delete(`${API_BASE_URL}/breake_problem/delete_breake_problem/${id}`);
      setShowDeleteModal(false);
      navigate(-1);
    } catch (e) {
      console.error('Ошибка при удалении записи:', e);
      setError('Не удалось удалить запись. Попробуйте снова.');
      setShowDeleteModal(false);
    } finally {
      setDeleteInProgress(false);
    }
  };

  if (loading) return <div>Загрузка...</div>;

  if (error) {
    return (
      <div className="check-details">
        <button className="back-btn" onClick={() => navigate(-1)}>← Назад</button>
        <p className="error-message">{error}</p>
      </div>
    );
  }

  // Формируем строки таблицы с деталями
  const detailRows = [];

  detailRows.push(['Участок', record.collector_name]);
  detailRows.push([
    'Состояние',
    record.is_operational === true
      ? 'Исправен'
      : record.is_operational === false
      ? 'Не исправен'
      : '—'
  ]);
  detailRows.push([
    'Дата обнаружения',
    record.date
      ? new Date(record.date).toLocaleDateString('ru-RU')
      : '—'
  ]);

  // Показываем «Дата закрытия» ТОЛЬКО если статус === 'Отработано' И у record.closing_date валидная дата
  if (
    record.status === 'Отработано' &&
    record.closing_date &&
    // Защитимся от «псевдодаты» типа пустой строки или неверного формата:
    !isNaN(new Date(record.closing_date).getTime())
  ) {
    detailRows.push([
      'Дата закрытия',
      new Date(record.closing_date).toLocaleDateString('ru-RU')
    ]);
  }

  detailRows.push(['Причина поломки', record.reason || '—']);
  detailRows.push(['Материалы', record.materials || '—']);
  detailRows.push(['Исполнитель', record.master_name || '—']);
  detailRows.push(['Статус', record.status || '—']);
  detailRows.push(['Комментарий', record.comments || '—']);

  return (
    <div className="check-details">
      <div className="details-header mobile-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <span className="back-icon">⌄</span>
        </button>
        <h1 className="page-title">Сведения о поломке</h1>
        <div className="actions">
          <button
            className="primary-btn delete-btn desktop-only"
            onClick={() => setShowDeleteModal(true)}
            disabled={deleteInProgress}
          >
            Удалить запись
          </button>
          <button
            className="primary-btn nn"
            onClick={() => navigate(`/check/${id}/edit`)}
            disabled={deleteInProgress}
          >
            Редактировать запись
          </button>
        </div>
      </div>

      <div className="details-container">
        <div className="table-container">
          <div className="table-wrapper">
            <table className="custom-table kkk">
              <colgroup>
                <col style={{ width: '25%' }} />
                <col />
              </colgroup>
              <tbody>
                {detailRows.map(([label, value], idx) => {
                  // Если по какой-то причине value = null / undefined / '' — показываем «—»
                  const displayValue =
                    value !== null && value !== undefined && value !== ''
                      ? value
                      : '—';
                  const isStatus = label === 'Статус';
                  const color = isStatus
                    ? displayValue === 'Отработано'
                      ? '#3cc962'
                      : displayValue === 'В процессе'
                      ? '#e6dd43'
                      : 'inherit'
                    : undefined;
                  return (
                    <tr key={idx}>
                      <td className="label">{label}</td>
                      <td className="value" style={isStatus ? { color } : {}}>
                        {displayValue}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="delete-container mobile-only">
      <button
        className="primary-btn delete-btn"
        onClick={() => setShowDeleteModal(true)}
        disabled={deleteInProgress}
      >
        Удалить запись
      </button>
    </div>


      {showDeleteModal && (
        <DeleteConfirmationModal
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleConfirmDelete}
        />
      )}
    </div>
  );
};

export default CheckDetails;
